import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { format } from 'date-fns';

import { dateFormat } from 'constants/formats';

import DocumentsList from 'modules/documents/components/DocumentsList';
import UploadDocument from 'modules/documents/components/UploadDocument';

import { useAddDraftInvestorModal } from '../context/AddDraftInvestorModalContext';

const ConvertibleNoteSafeOptionsSection: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useAddDraftInvestorModal();

  const dueDate = data.draftConditions?.dueDate;

  const showDocumentsSection = data.documents && data.documents.length > 0;

  return (
    <>
      <div className="form-group">
        <label className="form-label" htmlFor="contribution-date">
          {t('ContributionDate')}
        </label>
        <div className="form-control-wrap">
          <input
            id="contribution-date"
            type="date"
            className="form-control form-control-lg"
            value={data.contributionDate || ''}
            onChange={actions.handleChangeContributionDate}
            max={dueDate || undefined}
          />
        </div>

        <span className="sub-text mt-1 mb-3">
          {dueDate &&
            `${t('TheDateHasToBeLessThanNot')}${format(
              new Date(dueDate),
              dateFormat
            )}`}
        </span>
      </div>

      {showDocumentsSection && (
        <div className="my-3">
          <DocumentsList
            documents={[...data.documents, ...(data.file ? [data.file] : [])]}
          />
        </div>
      )}

      <UploadDocument
        label="AddConvertibleParticipato"
        inputLabel={data.file?.name || t('DragDocumentToUpload')}
        file={data.file}
        setFile={actions.handleChangeFile}
      />
    </>
  );
};

export default ConvertibleNoteSafeOptionsSection;
